import styled from 'styled-components';

const Group = styled.div.attrs({ 'data-testid': 'licence-type' })`
  margin-bottom: 60px;
`;

export default Group;
